import { render, staticRenderFns } from "./ExpedientGlobalVisionComponent.vue?vue&type=template&id=54b85554&scoped=true&lang=pug"
import script from "./ExpedientGlobalVisionComponent.vue?vue&type=script&lang=ts"
export * from "./ExpedientGlobalVisionComponent.vue?vue&type=script&lang=ts"
import style0 from "./ExpedientGlobalVisionComponent.vue?vue&type=style&index=0&id=54b85554&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54b85554",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('54b85554')) {
      api.createRecord('54b85554', component.options)
    } else {
      api.reload('54b85554', component.options)
    }
    module.hot.accept("./ExpedientGlobalVisionComponent.vue?vue&type=template&id=54b85554&scoped=true&lang=pug", function () {
      api.rerender('54b85554', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/expedients/ExpedientGlobalVision/ExpedientGlobalVisionComponent.vue"
export default component.exports